import { DetectedCardType } from '../../../types';

/**
 * Maps detected credit card type to predefined credit card type
 * @param {DetectedCardType} cardType - detected credit card type from onCardTypeDetected event
 * @returns {CreditCardType} Credit card type
 */
const mapDetectedCreditCardType = (cardType: DetectedCardType) => {
  if (cardType === 'mastercard') {
    return 'master';
  }
  if (cardType === 'american-express') {
    return 'american_express';
  }
  if (cardType === 'diners-club') {
    return 'diners_club';
  }
  if (cardType === 'default' || cardType === 'diners') {
    return null;
  }
  return cardType;
};

export default mapDetectedCreditCardType;
